<template>
<div v-if="isBanned" class="auth-form">
    <div class="auth-form__error">

        <div class="mt32 text-center">
            <div class="text-size-l text-bold text-color-red">Слишком много попыток входа!</div>
            <div class="mt16 text-size-ms">
                Вы заблокированы на 12 часов. Если у вас что-то срочное,<br>
                напишите администратору на <a href="mailto:zems@zems.pro">zems@zems.pro</a>
            </div>
        </div>
    </div>
</div>

<div v-else-if="isNoSuccess" class="auth-form">
    <div class="auth-form__error">
        <div class="text-center">
            <div>
<!--                                    <svg class="big-icon" >
                    <use xlink:href="@/assets/img/big-icons-sprite.svg#cat"></use>
                </svg>-->
            </div>

            <div class="text-size-l text-bold text-color-red mt32">
                У номера {{ user.phone ? user.phone : formAuthFields.login.value }} нет доступа к сайту
            </div>
            <div class="mt16 text-size-ms">
                Если он должен быть,<br>
                напишите администратору на <a href="mailto:zems@zems.pro">zems@zems.pro</a>
            </div>
        </div>
    </div>
</div>

<div v-else-if="isNoSuccessSection" class="auth-form" >
    <div class="auth-form__error">
        <div class="text-center">
            <div>
<!--                                    <svg class="big-icon" >
                    <use xlink:href="@/assets/img/big-icons-sprite.svg#cat"></use>
                </svg>-->
            </div>

            <div class="text-size-l text-bold text-color-red mt32">
                У номера {{ user.phone }} нет доступа<br>
                к этому разделу
            </div>
            <div class="mt16 text-size-ms">
                Если он должен быть,<br>
                напишите администратору на <a href="mailto:zems@zems.pro">zems@zems.pro</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    name: "AuthError",
    computed: {
        ...mapState({
            isUserLoaded: state => state.auth.isLoaded,
            user: state => state.auth.user,
            formAuthFields: state => state.auth.forms.auth.fields,
            isBanned: state => state.auth.isBanned,
            isNoSuccess: state => state.auth.isNoSuccess,
            isNoSuccessSection: state => state.auth.isNoSuccessSection,
            popups: state => state.popups.items,
            localStorage: state => state.auth.localStorage,
        }),
        ...mapGetters({
                needAuth:'auth/needAuth',
            }
        ),
    },
}
</script>

<style scoped>

</style>
